import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import TrendingSection from './components/TrendingSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import ArticleCTASection from './components/ArticleCTASection';

const siteUrl = typeof import.meta.env.VITE_SITE_URL === 'string' ? import.meta.env.VITE_SITE_URL : 'https://pandabuy.homes';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Pandabuy Sheet',
  url: siteUrl,
  description: 'Discover the best pandabuy sheet collections for clothing, sneakers, accessories and viral products. Updated daily with curated quality lists, budget finds, and trending product guides.',
  image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
  publisher: {
    '@type': 'Organization',
    name: 'Pandabuy.homes',
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
    },
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <main className="min-h-screen">
        <Navbar />
        <article>
          <HeroSection />
          <CategoryGrid />
          <TrendingSection />
          <AboutSection />
          <TestimonialSection />
          <ArticleCTASection />
        </article>
        <Footer />
      </main>
    </>
  );
}